import { render } from "./BaseBadge.vue?vue&type=template&id=d9189d3e&scoped=true"
import script from "./BaseBadge.vue?vue&type=script&lang=js"
export * from "./BaseBadge.vue?vue&type=script&lang=js"

import "./BaseBadge.vue?vue&type=style&index=0&id=d9189d3e&scoped=true&lang=css"

import exportComponent from "D:\\Dwiki\\learn-vue\\vue-cli\\practice\\coach-vue\\coach-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9189d3e"]])

export default __exports__